<template>
  <span class="DropDown">
    <span class="DropDown__inner">
      <select
        :id="id"
        class="DropDown__select"
        :value="value"
        :class="[
          { [`DropDown__select--error`]: isError },
          { [`DropDown__select--placeholder`]: placeholder && value === '' },
        ]"
        :name="name"
        :disabled="isDisabled"
        :aria-label="ariaLabel"
        :required="isRequired"
        @change="changeVal"
        @click="onClick"
      >
        <option v-if="placeholder" value="" disabled hidden>
          {{ placeholder }}
        </option>
        <option
          v-for="item in options"
          :key="item.text"
          class="DropDown__option"
          :class="{ ['DropDown__option--disabled']: item.disabled }"
          :value="item.value"
          :disabled="item.disabled"
          :selected="item.value === value"
        >
          {{
            item.isAddMsg && item.value !== value
              ? `${item.text} (${item.message})`
              : item.text
          }}
        </option>
      </select>
    </span>
    <span v-if="isError" class="DropDown__errorText">{{ errorText }}</span>
  </span>
</template>

<script>
export default {
  name: 'DropDown',
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    // modelValue: {
    //   type: String,
    // },
    name: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    ariaLabel: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: '',
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  emits: ['change', 'click'],
  methods: {
    changeVal(e) {
      this.$emit('change', e.target.value);
    },
    onClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.DropDown {
  $dropdown: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDE0LjY1TDcuNjAwMDEgMTAuMjVIMTYuNEwxMiAxNC42NVoiIGZpbGw9IiMwODE5MkQiLz4KPC9zdmc+Cg==';
  $dropdown-disabled: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjAwMDEgMTQuNjVMNy42MDAxIDEwLjI1SDE2LjQwMDFMMTIuMDAwMSAxNC42NVoiIGZpbGw9IiNCRkJGQkYiLz4KPC9zdmc+Cg==';
  $icon-size: $service-unit * 6;

  display: block;

  &__inner {
    position: relative;
    display: inline-flex;
    width: 100%;
    height: $service-unit * 10;
    color: $color-gray-80;
    background-color: $color-white-100;
    border-radius: $service-border-radius;
  }

  &__option {
    color: $color-gray-80;

    &--disabled {
      color: $color-gray-50;
    }
  }
  &__select {
    width: 100%;
    height: 100%;
    padding: 0 $service-unit * 8 0 $service-unit * 4;
    font-size: $service-font-size-p;
    color: inherit;
    cursor: pointer;
    background: url($dropdown) no-repeat right $service-unit * 2 center /
      $icon-size $icon-size;
    border: 1px solid $color-gray-50;
    border-radius: inherit;
    appearance: none;

    &--placeholder {
      color: $color-gray-50;
    }

    &::-ms-expand {
      display: none;
    }

    &:invalid {
      color: $color-gray-50;
    }

    &:hover {
      border: 1px solid $color-blue-60;
    }

    &:focus {
      outline: 2px solid $color-blue-60;
    }

    &:disabled {
      color: $color-gray-50;
      cursor: inherit;
      background: $color-gray-30 url($dropdown-disabled) no-repeat right
        $service-unit * 2 center / $icon-size $icon-size;
      border: 0;
    }

    &--error {
      border: 2px solid $color-red-70;

      &:hover {
        border: 2px solid $color-red-70;
      }
    }
  }

  &__errorText {
    display: block;
    margin-top: $service-unit;
    font-size: $service-font-size-pp;
    color: $color-red-70;
    text-align: left;
  }
}
</style>
